import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { Report } from "src/app/models/reports";
import { TableColumn } from "src/app/models/table";
import { AgentCRMService } from "src/app/services/agent-crm.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-report-history-table',
    templateUrl: './report-history-table.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportHistoryTableComponent implements OnInit, OnChanges {
    @Input() public reports: Report[];
    @Input() public deleteEnabled: boolean;

    @Output() public emitDelete: EventEmitter<Report> = new EventEmitter();

    public reportMatTableData: MatTableDataSource<Report>;
    public reportColumns: TableColumn[] = [
        {
            columnName: 'Status',
            propertyId: 'status',
            columnType: TableColumnType.label,
            width: '10%',
        },{
            columnName: 'File Name',
            propertyId: 'name',
            columnType: TableColumnType.label,
        },{
            columnName: 'Category',
            propertyId: 'category',
            columnType: TableColumnType.label,
        },{
            columnName: 'Date Created',
            propertyId: 'createdDate',
            columnType: TableColumnType.label,
            width: '10%',
        },{
            columnName: 'Download',
            propertyId: 'reportID',
            columnType: TableColumnType.button,
            dataTypeText: 'Download',
            isBooleanPropertyId: 'isFileCreated',
            width: '17%',
        },
    ];

    constructor(
        private agentCRMService: AgentCRMService,
        private helperService: HelperService,
    ) {
    }

    ngOnInit(): void {
        if (this.deleteEnabled) {
            this.reportColumns.push({
                propertyId: 'deleteReportID',
                columnName: 'Delete',
                columnType: TableColumnType.button,
                dataTypeText: 'Delete',
                cssCustomClass: 'mwp-button-delete',
                isBooleanPropertyId: 'isFileCreated',
                isButtonSelection2: true,
                width: '17%',
            });
        }
        this.loadForm();
    }

    ngOnChanges(): void {
        this.loadForm();
    }

    private loadForm(): void {
        this.reportMatTableData = new MatTableDataSource<Report>();
        this.reportMatTableData.data = this.reports;
    }

    public downloadDocument(report: Report): void {
        this.agentCRMService.getReportById(report.reportID).subscribe((response: Blob) => {
            let l_BinaryData = [];
            l_BinaryData.push(response);
            this.helperService.downloadDocument(l_BinaryData, response.type, report.name);
        });
    }

    public deleteReport(report: Report): void {
        this.emitDelete.emit(report);
    }
}
